import facebookService from 'services/facebookService'
import tikTokService from 'services/tikTokService'
import heapService from 'services/heapService'

const adsFacade = {

  recordAddToCartEvent: ({ eventId, identity }) => {
    facebookService.recordAddToCartEvent({ eventId })
    tikTokService.recordAddToCartEvent({ eventId })
    heapService.recordAddToCartEvent({ phone: identity.phone, email: identity.email })
  },

  recordPurchaseEvent: ({ eventId }) => {
    facebookService.recordPurchaseEvent({ eventId })
    tikTokService.recordPurchaseEvent({ eventId })
  }
}

export default adsFacade
